import React from 'react'
import { TurnPanelConceptGallery } from './turn-panel-concepts'

export default function FourthRoundGallery() {
  return <TurnPanelConceptGallery round={4} />
}
